import type { IconNode } from '../types';

/**
 * @name margin
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB4PSI5IiB5PSI5IiB3aWR0aD0iNiIgaGVpZ2h0PSI2IiByeD0iMSIgLz4KICA8cGF0aCBkPSJNMjEgNnYxMiIgLz4KICA8cGF0aCBkPSJNMyA2djEyIiAvPgogIDxwYXRoIGQ9Ik02IDIxaDEyIiAvPgogIDxwYXRoIGQ9Ik02IDNoMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/margin
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Margin: IconNode = [
  ['rect', { x: '9', y: '9', width: '6', height: '6', rx: '1' }],
  ['path', { d: 'M21 6v12' }],
  ['path', { d: 'M3 6v12' }],
  ['path', { d: 'M6 21h12' }],
  ['path', { d: 'M6 3h12' }],
];

export default Margin;
